import { Map, Record } from "immutable";
import { RootState, RootActions } from "common/reducers";
import { receive, reset } from "common/reducers/Utils";
import { roomFromJSON, RoomRecord } from "common/records/Room";
import { RECEIVE_ROOM, EDIT_ROOM, RESET_ROOMS, RESET_ROOM } from "common/reducers/room.actions";

export const RoomStateRecord = Record({
  byId: Map<number, RoomRecord>(),
  lastSavedById: Map<number, RoomRecord>(),
  unsavedId: -1,
});

export const initialState = RoomStateRecord();
export type RoomState = typeof initialState;

const model = "rooms";

export const roomReducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }
  switch (action.type) {
    case RESET_ROOM:
      return reset(state, model, action.payload.roomId);

    case RECEIVE_ROOM:
      return receive(state, model, roomFromJSON(action.payload.room));

    case EDIT_ROOM:
      const room = roomFromJSON({ ...action.payload.room });

      return state.setIn([model, "byId", room.id], room);

    default:
      return state;
  }
};
